var _ellipse, _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtendedPurpose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 29,
    viewBox: "0 0 40 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 15,
    rx: 14,
    ry: 14,
    fill: "#99CCFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 3.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white",
    stroke: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 7.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white",
    stroke: "#333333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 11.5,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "white",
    stroke: "#333333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 13.5,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "#333333",
    stroke: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6531 2.0918L18.7811 3.33364L17.9092 4.57549",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4097 5.23047L16.8523 4.76016L18.295 4.28986",
    stroke: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5093 3.25L19.6373 4.49185L18.7654 5.73369",
    stroke: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2656 6.38867L17.7083 5.91837L19.151 5.44806",
    stroke: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0532 3.41924L18.7971 0.935547L21.3653 4.40749L19.6214 6.89118",
    stroke: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4388 3.13361L14.5535 4.07422L17.1217 7.54616L20.007 6.60555",
    stroke: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.235 15.4267L17.1035 3.08203",
    stroke: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6777 15C21.6777 20.2467 17.4244 24.5 12.1777 24.5C6.93103 24.5 2.67773 20.2467 2.67773 15C2.67773 9.75329 6.93103 5.5 12.1777 5.5C17.4244 5.5 21.6777 9.75329 21.6777 15Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1982 21.5H13.8018V11.7969H10.1982V21.5ZM12 11.2607C13.0195 11.2607 13.793 10.5225 13.793 9.55566C13.793 8.58887 13.0195 7.85059 12 7.85059C10.9805 7.85059 10.207 8.58887 10.207 9.55566C10.207 10.5225 10.9805 11.2607 12 11.2607Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendedPurpose);
export default __webpack_public_path__ + "static/media/ExtendedPurpose.935c088ca362ffbfb3d554eff6e548e2.svg";
export { ForwardRef as ReactComponent };